<template>
  <div class="boxbgcolor poslist">
    <div class="left content-left">
      <AreaTree v-on:handleTreeClick="handleTreeClick"></AreaTree>
    </div>
    <div class="right content-right">
      
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <input
              v-model="search.name"
              class="form-control"
              type="text"
              placeholder="请输入商户名称"
              size="12"
              v-noBlankSpace
            />
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button @click="searchList" type="button" class="btn btn-primary" id="search_btn" :disabled="loading">
              <i v-if="loading" class="el-icon-loading"></i>
              {{ loading ? "查询中..." : "查询" }}
            </button>
            </span>
            <span class="add_btn">
              <button type="button" class="btn btn-default" @click="addrOrEdit()">添加</button>
            </span>
            

            
          </div>
        </form>
      </div>
      <div class="list-right">
        <el-table v-loading="loading" element-loading-text="加载中..."
          border
          height="100%"
          :data="tableListData"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
          <el-table-column show-overflow-tooltip label="商户号" prop="mchid"></el-table-column>
          <el-table-column show-overflow-tooltip label="商家名称" prop="name"></el-table-column>
          <el-table-column show-overflow-tooltip label="商家地址" prop="address"></el-table-column>

          <el-table-column show-overflow-tooltip label="余额" prop="money"></el-table-column>

          <el-table-column show-overflow-tooltip label="操作" width="200px">
            <template slot-scope="scope">
              <button class="edit operate-button" type="button" @click="addrOrEdit(scope.row.id)">修改</button>
              <button class="delete operate-button" @click="del(scope.row.id)" type="button">删除</button>
              <button
                class="delete operate-button"
                @click="resetPassword(scope.row.id,scope.row.mchid)"
                type="button"
              >重置密码</button>
              <button
                class="delete operate-button"
                @click="recharge(scope.row.id,scope.row.name,scope.row.money)"
                type="button"
              >充值</button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- <Page :pageSize="search.pageSize"></Page> -->
    <Page v-on:pagination="receivePaginationData"></Page>
    <!--新增或修改-->
    <el-dialog
      title="新增或修改商户"
      :visible.sync="dialogFormVisible"
      :lock-scroll="false"
      :close-on-click-modal="false"
      width="40%"
      @close="resetForm"
    >
      <el-form label-width="100px" size="mini" ref="addOrEditForm" :model="formData" :rules="rules">
        <el-form-item label="商户号">
          <el-input v-if="formData.id" v-model="formData.mchid" readonly></el-input>
          <el-input v-else v-model="formData.mchid"></el-input>
        </el-form-item>
        <el-form-item label="商家地址">
          <el-input v-model="formData.address"></el-input>
        </el-form-item>
        <el-form-item label="商家名称" prop="name">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item label="商家密码" v-if="!(formData.id)">
          <el-input v-model="formData.password" type="password"></el-input>
          <span class="promptText">默认密码0123456</span>
        </el-form-item>
        <!-- <el-form-item label="可透支金额" class="sameLine" v-model='crtName'>
					<el-input ></el-input><span class='tip'>元(0 表示不可透支)</span>
        </el-form-item>-->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addOrEditTrue">确定</el-button>
        <el-button @click="dialogFormVisible = false">取消</el-button>
      </span>
    </el-dialog>
    <!--充值-->
    <el-dialog
      title="充值"
      :visible.sync="dialogRechargeVisible"
      :lock-scroll="false"
      :close-on-click-modal="false"
      width="40%"
    >
      <el-form label-width="100px" size="mini">
        <el-form-item label="商家名称">
          <el-input v-model="rechargeFormData.name"></el-input>
        </el-form-item>
        <el-form-item label="当前金额">
          <el-input v-model="rechargeFormData.currentMoney"></el-input>
        </el-form-item>
        <el-form-item label="充值金额">
          <el-input v-model="rechargeFormData.rechargeMoney"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="reChargeTrue()">确定</el-button>
        <el-button @click="dialogRechargeVisible = false">取消</el-button>
      </span>
    </el-dialog>
    <!-- 修改密码 -->
    <!-- <el-dialog
      title="重置密码"
      :visible.sync="dialogResetVisible"
      :lock-scroll="false"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form label-width="100px" size="mini">
        <el-form-item label="商家名称">
          <el-input v-model="resetFormData.name"></el-input>
        </el-form-item>
        <el-form-item label="原密码">
          <el-input v-model="resetFormData.Password"></el-input>
        </el-form-item>
        <el-form-item label="请输入新密码">
          <el-input v-model="resetFormData.newPassword"></el-input>
        </el-form-item>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="resetTrue()">确定</el-button>
        <el-button @click="dialogResetVisible = false">取消</el-button>
      </span>
    </el-dialog>-->
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import {
  getPosList,
  addShopUser,
  editShopUser,
  userRecharge,
  getOneShopUser,
  resetPassword,
  //  resetPasswordV
} from "@/api/url";

import Page from "../../commons/parking/commons/page.vue";

import AreaTree from "../../commons/parking/commons/areaTree.vue";

import Refresh from "../../commons/parking/commons/refresh.vue";

export default {
  data() {
    return {
      loading: false,
      treeData: {
        parkingId: "",
        areaId: "",
      },
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      dialogFormVisible: false,
      dialogRechargeVisible: false,
      dialogResetVisible: false,
      allFbType: [],
      search: {
        pageNumber: 1,
        pageSize: 10,
        name: "",
        // carType:"",
        // plateType:"",
        // openMethod:"",
        // beginDate:'',
        // endDate:''
      },
      formData: {
        id: "",
        mchid: "",
        name: "",
        password: "0123456",
        address: "",
      },
      rechargeFormData: {
        name: "",
        id: "",
        currentMoney: "",
        rechargeMoney: "",
      },
      resetFormData: {
        name: "",
        id: "",
        // password:"",
        newPassword: "",
      },
      tableListData: [],
      allCarTypes: null,
      allPlateTypes: null,
      allOpenMethods: null,
      defaultProps: {
        children: "children",
        label: "label",
      },

      formLabelWidth: "100px",

      allImgUrl: [],
      imgUrl: "",
      rules: {
        name: [{ required: true, message: "请填写商家名称", trigger: "blur" }],
      },
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      if (!this.treeData.parkingId) {
        this.$message({
          type: "warning",
          message: "请选择停车场",
        });
        return;
      }
      this.tableList(this.search.pageNumber);
    },
    //点击树的节点展示相应数据
    handleTreeClick: function (node, data) {
      this.search.name = "";
      if (node.type === "parking") {
        this.treeData.parkingId = node.id;
        this.search.pageNumber = 1;
        this.tableList(this.search.pageNumber);
      } else {
        this.treeData.parkingId = "";
        this.tableListData = [];
        //  this.$message({
        // 	message: '请选择车场！',
        // 	type: 'warning'
        // 	});
      }
    },
    tableList: function (curPage) {
      this.loading = true;
      var _this = this;
      this.$get(getPosList(), {
        parkingId: this.treeData.parkingId,
        name: this.search.name,
        limit: this.search.pageSize,
        page: curPage,
      }).then((data) => {
        if (data.status != 200) return;
        //翻页
        var rows = data.data.rows;
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.getPage(pageObj);
        _this.tableListData = data.data.rows;
      }).finally(() => {
        this.loading = false;
      });
},
    searchList: function () {
      if (this.loading) return;
      if (!this.treeData.parkingId) {
        this.$message({
          type: "warning",
          message: "请选择车场",
        });
        return;
      }
      this.search.pageNumber = "1";
      this.tableList(this.search.pageNumber);
    },
    clearSearch: function () {
      this.search.pageNumber = "1";
      this.search.fbMsg = "";
      this.tableList(this.search.pageNumber);
    },
    addrOrEdit(id) {
      var _this = this;

      if (id) {
        this.dialogFormVisible = true;
        this.$postRequest(getOneShopUser(), {
          id: id,
        }).then((data) => {
          if (data.status != 200) return;
          this.formData.mchid = data.data.mchid;
          this.formData.name = data.data.name;
          // this.formData.password = data.data.password;
          this.formData.address = data.data.address;
          this.formData.id = data.data.id;
        });
      } else {
        if (this.treeData.parkingId) {
          this.dialogFormVisible = true;
          this.formData.mchid = "";
          this.formData.name = "";
          this.formData.password = "0123456";
          this.formData.address = "";
          this.formData.id = "";
        } else {
          this.dialogFormVisible = false;
          this.$message({
            message: "请选择车场!",
            type: "warning",
          });
        }
      }
    },
    addOrEditTrue() {
      var _this = this;
      this.$refs.addOrEditForm.validate(function (valid) {
        if (valid) {
          _this.dialogFormVisible = false;
          if (_this.formData.id) {
            _this
              .$putRequest(editShopUser(), {
                id: _this.formData.id,
                name: _this.formData.name,
                password: _this.formData.password,
                mchid: _this.formData.mchid,
                address: _this.formData.address,
                parkingId: _this.treeData.parkingId,
              })
              .then((data) => {
                if (data.status != 200) {
                  _this.$notify({
                    type: "warning",
                    title: "失败",
                    message: data.message,
                  });
                  return;
                }
                _this.$notify({
                  type: "success",
                  title: "成功",
                  message: "修改成功！",
                });
                _this.tableList(_this.curIndex);
              });
          } else {
            _this
              .$postRequest(addShopUser(), {
                name: _this.formData.name,
                password: _this.formData.password,
                mchid: _this.formData.mchid,
                address: _this.formData.address,
                parkingId: _this.treeData.parkingId,
              })
              .then((data) => {
                if (data.status != 200) {
                  _this.$notify({
                    type: "warning",
                    title: "失败",
                    message: data.message,
                  });
                  return;
                }
                _this.$notify({
                  type: "success",
                  title: "成功",
                  message: "添加成功！",
                });
                _this.search.pageNumber = 1;
                _this.tableList(_this.search.pageNumber);
              });
          }
        } else {
        }
      });
    },
    // del(id) {
    //   this.$deleteRequest(addShopUser() + "/" + id).then(data => {
    //     if (data.status != 200) return;
    //     this.$notify({
    //       type: "success",
    //       title: "成功",
    //       message: "删除成功！"
    //     });
    //     this.tableList(this.curIndex);
    //   });
    // },
    del: function (id) {
      var _this = this;
      var index = _this.$layer.confirm(
        "您确定删除？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function () {
          _this.$layer.close(index);

          _this
            .$deleteRequest(addShopUser() + "/" + id + "?id=" + id)
            .then((data) => {
              if (data.status != 200)
                return _this.$layer.msg("删除失败", { time: 1 });
              _this.$notify({
                type: "success",
                title: "成功",
                message: "删除成功！",
              });
              _this.tableList(_this.curIndex);
            });
        }
      );
    },
    // 重置密码
    resetPassword: function (password, id) {
      var _this = this;
      this.$putRequest(resetPassword(), {
        id: this.formData.mchid,
        password: this.formData.password,
      }).then((data) => {
        if (data.status != 200) return;
        this.$notify({
          title: "成功",
          message: "重置密码成功,默认密码是0123456",
          type: "success",
        });
      });
    },

    // 修改密码
    //   resetPassword(id,name, password) {
    //   this.dialogResetVisible = true;
    //   this.resetFormData.id = id;
    //   this.resetFormData.name = name;
    //   // this.resetFormData.password = password
    //   this.resetFormData.newPassword = "";
    // },
    // resetTrue() {
    //   this.dialogResetVisible = false;
    //   this.$postRequest(resetPasswordV(), {
    //     id: this.resetFormData.id,
    //     password: this.resetFormData.newPassword
    //   }).then(data => {
    //     if (data.status != 200) return;
    //     this.$notify({
    //       type: "success",
    //       title: "成功",
    //       message: "修改成功！"
    //     });
    //     this.tableList(this.curIndex);
    //   });
    // },
    // 充值
    recharge(id, name, cMoney) {
      this.dialogRechargeVisible = true;
      this.rechargeFormData.id = id;
      this.rechargeFormData.name = name;
      this.rechargeFormData.currentMoney = cMoney;
      this.rechargeFormData.rechargeMoney = "";
    },
    reChargeTrue() {
      this.dialogRechargeVisible = false;
      this.$postRequest(userRecharge(), {
        id: this.rechargeFormData.id,
        money: this.rechargeFormData.rechargeMoney,
      }).then((data) => {
        if (data.status != 200) return;
        this.$notify({
          type: "success",
          title: "成功",
          message: "充值成功！",
        });
        this.tableList(this.curIndex);
      });
    },
    close() {
      this.formData.mchid = "";
      this.formData.name = "";
      this.formData.password = "";
      this.formData.address = "";
      this.formData.id = "";
    },
    resetForm() {
      this.$refs["addOrEditForm"].resetFields();
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
  },
  components: {
    Page,
    AreaTree,
    Refresh,
  },
  mounted: function () {
    // this.tableList(this.search.pageNumber);
  },
};
</script>

<style scoped>
.sameLine .el-form-item__content .el-input {
  display: inline-block;
  width: 70%;
}
.tip {
  color: red;
}
</style>
<style>
</style>